import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  listCustomDashboards,
  getCustomDashboard,
  createCustomDashboard,
  updateCustomDashboard,
  deleteCustomDashboard,
} from "../../../../apis/apiCustomDashboard";

// react-query is the app's server-cache layer (see Dashboardv2 / App.jsx). The
// viewer reads a dashboard once and renders from the frozen snapshot, so these
// queries are plain fetch+cache; mutations invalidate the list + detail.

const ROOT = "custom-dashboards";
const listKey = (type) => [ROOT, "list", type ?? null];
const detailKey = (id) => [ROOT, "detail", id];

export const useCustomDashboardList = (type) =>
  useQuery({
    queryKey: listKey(type),
    queryFn: () => listCustomDashboards(type),
  });

export const useCustomDashboard = (id) =>
  useQuery({
    queryKey: detailKey(id),
    queryFn: () => getCustomDashboard(id),
    enabled: !!id,
  });

export const useCustomDashboardMutations = () => {
  const qc = useQueryClient();
  const invalidate = () => qc.invalidateQueries({ queryKey: [ROOT] });

  const create = useMutation({
    mutationFn: createCustomDashboard,
    onSuccess: invalidate,
  });

  const update = useMutation({
    mutationFn: updateCustomDashboard,
    onSuccess: (data, vars) => {
      if (vars?.id) qc.invalidateQueries({ queryKey: detailKey(vars.id) });
      qc.invalidateQueries({ queryKey: [ROOT, "list"] });
    },
  });

  const remove = useMutation({
    mutationFn: deleteCustomDashboard,
    onSuccess: invalidate,
  });

  return { create, update, remove };
};
